import React from "react";
import { trackTabs, type TrackTab } from "../../content/site";

type TabBarProps = {
    active: TrackTab;
    onChange: (tab: TrackTab) => void;
    tabs?: readonly TrackTab[];
    variant?: "default" | "program";
};

export function TabBar({ active, onChange, tabs = trackTabs, variant = "default" }: TabBarProps) {
    const isProgramVariant = variant === "program";

    return (
        <div className="relative mb-6">
            <div
                className="scrollbar-none relative z-10 flex overflow-x-auto overflow-y-hidden max-md:flex-nowrap"
                role="tablist"
                aria-label="Треки"
            >
                {tabs.map((tab) => {
                    const isActive = tab === active;
                    const isLastTab = tab === tabs[tabs.length - 1];

                    return (
                        <button
                            key={tab}
                            type="button"
                            role="tab"
                            aria-selected={isActive}
                            className={[
                                "relative shrink-0 whitespace-nowrap px-12 text-[32px] leading-none tracking-[-0.04em] transition-colors max-md:px-6 max-md:text-[22px]",
                                isProgramVariant
                                    ? "pb-[26px] max-md:pb-[22px]"
                                    : "pb-[22px] max-md:pb-[18px]",
                                isActive ? "font-medium text-white" : "text-muted",
                            ].join(" ")}
                            onClick={() => onChange(tab)}
                        >
                            {tab}
                            <span
                                className={[
                                    "absolute left-0 z-20 transition-all",
                                    isLastTab ? "-right-[6px]" : "right-0",
                                    isProgramVariant ? "bottom-0 h-[8px]" : "bottom-0 h-[4px]",
                                    isActive ? "bg-accent" : "bg-transparent",
                                ].join(" ")}
                            />
                        </button>
                    );
                })}
            </div>
            <div
                className={[
                    "pointer-events-none absolute right-0 left-0 z-0 h-[4px] bg-line",
                    isProgramVariant ? "bottom-[2px]" : "bottom-0",
                ].join(" ")}
                aria-hidden="true"
            />
        </div>
    );
}
